import NavLinks from "./nav-links";
import QLOLogo from '../assets/QLOLogoMark.png';
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import CustomMargin from "./custom-margin";
import NavHome from "../pages/home/components/nav-home";
import { Link } from 'react-router-dom';

export default function TopNav(){
    let location = useLocation();
    const { pathname } = location;
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const path = {
        '/':'Home',
        '/about/':'About us',
        '/practices/':'Practices',
        '/careers/':'Careers',
        '/feedback/':'Feedback',
        '/contact/':'Contact Us'
    };

    const title = path[pathname] || '';
    const minHeight = pathname === '/' ? 'min-h-screen' : 'min-h-auto';

    //This will change the document title every clicks on the navigation links
    useEffect(() => {
        const handleScroll = () => {
            if(window.scrollY > 0) {
                setScrolled(true);
            }else{
                setScrolled(false);
            }
        }

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, [pathname, title])

    return(
        <div className={`relative bg-heroPattern bg-cover bg-center ${minHeight}`}>
            <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/60 to-[#090909]" />
            <CustomMargin>
                <div className={`relative z-[101] flex items-center justify-between px-5 py-5 lg:px-10 ${scrolled ? 'opacity-0':''} ${mobileMenuOpen ? 'bg-[#090909] shadow-2xl shadow-black' : ''} transition-all duration-300 ease-in-out`}>
                    <Link
                        to='/' 
                    >
                        <img 
                            src={QLOLogo} 
                            alt="QLO Logo"
                            className="w-44 sm:w-60 md:w-72" />
                    </Link>
                    <div>
                        <NavLinks onMobileMenuChange={setMobileMenuOpen}/>
                    </div>
                </div>
                <div className="relative z-10">
                    {title === 'Home' ? (
                        <CustomMargin className="p-5">
                            <NavHome/>
                        </CustomMargin>
                    ): (
                        <h1 className="mt-10 px-5 pb-10 text-center font-fontMontserrat text-4xl text-white sm:text-5xl lg:text-7xl">{title}</h1>
                    )}
                </div>
            </CustomMargin>
        </div>
    )
} 
